/**
 * @namespace Search
 * @aka SWR.Search
 */
SWR.Search = (function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'search';
  var DATA_KEY = 'swr.' + NAME;
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Event = {
    PJAX_DATA_API: 'pjax:end' + EVENT_KEY + DATA_API_KEY
  };

  var Selector = {
    DATA_SPY: '#header .navbar-search'
  };

  /*
   TODO: private helpers go here.
   */

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  var Search = function () {

    // Tabbing wird verhindert - wenn das Formular nicht sichtbar ist
    var hiddenSearchNoTab = function() {
      $('.navbar-search-wrapper, .navbar-search-wrapper input, .navbar-search-wrapper button').attr("tabindex", "-1");
    }

    // Verhinderung des Tabbing wird wieder entfernt.
    var showSearchNoTabindex = function() {
      $('.navbar-search-wrapper, .navbar-search-wrapper input, .navbar-search-wrapper button').attr("tabindex", "");
    }

    function Search(element) {
      var self = this;

      // protected
      self.element = element;
      self.$element = $(self.element);
      self.$input = self.$element.find('[name="q"]');
      if (0 === self.$input.length) {
        self.$input = self.$element.find('[name="swx_q"]');
      }

      hiddenSearchNoTab();

      //Nach PJAX-Navigation:
      $(document).on('pjax:end', function () {
        //Input leeren
        self.$input.val('');
        self.$input.blur();
        $(document).off('click' + EVENT_KEY + DATA_API_KEY);

        //Suche nachdem gesucht wurde ausblenden
        if($('.navbar-search-wrapper').hasClass('search-open')){
          $(document).trigger('header:search:close', false);
        }
      });

      //Input leeren
      self.$input.val('');
      self.$input.blur();
      $(document).off('click' + EVENT_KEY + DATA_API_KEY);

      //Suche nachdem gesucht wurde ausblenden
      if($('.navbar-search-wrapper').hasClass('search-open')){
        $(document).trigger('header:search:close', false);
      }

      self._moveSuggestion();
      self._events();
    }

    Search.prototype._moveSuggestion = function _moveSuggestion() {
      $('.search-overlay').append($('.swr-autocomplete-header'));
    };

    Search.prototype._events = function _events() {
      var self = this;

      var $close_btn = $('.search-button-animated');
      var $wrapper = $('.navbar-search-wrapper');
      var $contentWrapper = $('#content-wrapper');
      var $playerbar = $('#playerbar');
      var $naviHeader = $('#header-main-navi-header');

      //Beim Klick auf den Button in der Navileiste oben oder den Abbrechen-Button
      //im Suchoverlay soll das Overlay geschlossen/geöffnet werden
      //Der Focus wird beim Öffnen automatisch ins Suchfeld gesetzt
      $(document).on('header:search:open', function(event, data){
        showSearchNoTabindex();

        try {
          if (data) {
            //User-Click
            //PIANO-Usability-Click senden
            PIANO.UsabilityClick.usabilityClickEvent({
              'type': 'action',
              'click': 'Suche im Header wird geöffnet',
              'click_chapter1': 'Menü',
              'click_chapter3': 'Suche'
            });
          }
        } catch (e) {
          console.warn(e);
        }

        if(window.outerWidth >= 992) {
          //Auf dem Desktop wird der ganze Wrapper versteckt
          $wrapper.hide();
        } else {
          //Mobil wird nur das Eingabefeld versteckt
          self.$element.hide();
        }

        $([$wrapper, self.$element, $close_btn, $playerbar, $contentWrapper, $naviHeader]).each(function() {
          $(this).addClass('search-open');
        });

        //Der graue Hintergrund wird eingefadet
        $contentWrapper.removeClass('background-fade-out').addClass('background-fade-in');

        setTimeout(function(){
          $contentWrapper.removeClass('background-fade-in');
        }, 1000);

        if(window.outerWidth >= 992) {
          //Auf dem Desktop wird das komplette Suchoverlay eingefadet
          $wrapper.fadeIn('slow');
        } else {
          //Mobil wird nur das Eingabefeld eingefadet, das sonst der Animierte Button springt
          self.$element.fadeIn('slow');
        }

        self.$input[0].focus();

        //Der Top-Button wird ausgeblendet, damit er nicht vor dem grauen Hintergrund steht
        $('a.back-to-top').fadeOut('slow');
      });

      $(document).on('header:search:close', function (event, data) {
        hiddenSearchNoTab();

        //User-Click
        //PIANO-Usability-Click senden
        try {
          PIANO.UsabilityClick.usabilityClickEvent({
            'type': 'action',
            'click': 'Suche im Header wird geschlossen',
            'click_chapter1': 'Menü',
            'click_chapter3': 'Suche'
          });
        } catch (e) {
          console.warn(e);
        }

        //Der graue Hintergrund wird ausgefadet
        $contentWrapper.removeClass('background-fade-in').addClass('background-fade-out');
        hiddenSearchNoTab();

        setTimeout(function(){
          $contentWrapper.removeClass('background-fade-out');
        }, 1000);

        $close_btn.removeClass('search-open');

        //Auf dem Desktop wird das komplette Suchoverlay ausgefadet
        //Mobil wird nur das Eingabefeld ausgefadet, das sonst der Animierte Button springt
        const $fadeOutElement = window.outerWidth >= 992 ? $wrapper : self.$element;

        $fadeOutElement.fadeOut('slow', function () {
          $([$wrapper, self.$element, $playerbar, $contentWrapper, $naviHeader]).each(function() {
            $(this).removeClass('search-open');
          });
        });
      })

      $close_btn.on('click', function (){
        if (!$wrapper.hasClass('search-open')) {
          //Suche geschlossen

          //Wenn Menü geöffnet Menü schließen
          if ($naviHeader.hasClass('menu-open')) {
            $(document).trigger('header:menu:close', false);
          }
          //Suche öffnen
          $(document).trigger('header:search:open', true);
        }else {
          //Suche ist geöffnet und wird geschlossen
          $(document).trigger('header:search:close', true);
        }
      });

      $(document).on('click' + EVENT_KEY + DATA_API_KEY, function (event){
        if($wrapper.hasClass('search-open')) {
          if ($(event.target).closest('.search-overlay').length === 0 && $(event.target).closest('.search-button-animated').length === 0) {
            //Suche schließen
            $(document).trigger('header:search:close', false);
          }
        }
      });

      //Beim Schreiben wird der Löschbutton eingeblendet
      self.$input.on('keyup', function () {
        if(self.$input.val().length > 0) {
          $('.btn-delete-search').show();
          self.$input.addClass('active');
        } else {
          $('.btn-delete-search').hide();
          self.$input.removeClass('active');
        }
      });

      //Beim Klick auf den Such-Eingabe-Löschen-Button (x) wird das Suchfeld
      //geleert und die Suchvorschläge ausgeblendet
      $('.btn-delete-search').click(function () {
        self.$input.val('');
        self.$input[0].focus();
        $('.swr-autocomplete-header').hide();
        $(this).hide();
      });

      self.$input.off('click');
      self.$input.off('focusin');
      self.$input.off('focusout');
    };

    // public
    Search.prototype.dispose = function dispose() {
      this.$element.off(EVENT_KEY);

      this.$element.find('.close-btn').remove();

      this.$element = null;
      this.element = null;

      $(document).off(EVENT_KEY);
    };

    // static
    Search._jQueryInterface = function _jQueryInterface() {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);

        if (!data) {
          data = new Search(this);
          $(this).data(DATA_KEY, data);
        }
      });
    };

    return Search;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  $(Selector.DATA_SPY).each(function () {
    var $element = $(this);
    Search._jQueryInterface.call($element, $element.data());
  });
  $(document).on(Event.PJAX_DATA_API, function (event, xhr, options) {
    $(options.container).find(Selector.DATA_SPY).each(function () {
      var $element = $(this);
      Search._jQueryInterface.call($element, $element.data());
    });
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $.fn[NAME] = Search._jQueryInterface;
  $.fn[NAME].Constructor = Search;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Search._jQueryInterface;
  };

  return Search;

})(window.jQuery);
